// extracted by mini-css-extract-plugin
export default {"container":"AddCalendar_container__XKRXN","link":"AddCalendar_link__UNGNC","tutorial":"AddCalendar_tutorial__DOvdG"};